import { createApp } from 'vue';
import RafToPngConverter from '../Components/RafToPngConverter.vue';

const root = document.getElementById('raf-to-png-converter');
if (root) {
  createApp(RafToPngConverter).mount('#raf-to-png-converter');
}
